import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';
import AuthService from '../utils/AuthService';
import logoImage from '../../styles/images/sqwad-hand.png';
import logoWithTextImageBlack from '../../styles/images/new_sqwad_logo.png';
import '../../styles/css/main.css';
import swal from 'sweetalert2';

class AdminLogin extends Component {
    constructor(props) {
        super(props);
        this.authWithEmailPassword = this.authWithEmailPassword.bind(this)
        this.Auth = new AuthService();
        this.state = {
          loading: true,
          redirect: false
        };
    }

    authWithEmailPassword(event) {
      event.preventDefault()
      const email = this.emailInput.value
      const password = this.passwordInput.value
      this.setState({loading:true})
      this.Auth.login(email, password).then(res => {
        this.setState({loading:false})
        if(res.tenantId){
          swal({
              title: 'Uh Oh!',
              text: "Looks like the url is wrong or this tenant has been shut down",
              type: 'warning',
              confirmButtonText: 'Ok'
            })
          return;
        }
        if(res.login_failure){
          swal({
              title: 'Uh Oh!',
              text: res.login_failure[0],
              type: 'warning',
              confirmButtonText: 'Ok'
            })
          return;
        }
        this.props.checkIfAuthenticated();
        this.setState({redirect: true})
      })
      .catch(err => {
        swal({
            title: 'Uh oh!',
            text: err,
            type: 'error',
            confirmButtonText: 'Ok'
          })
      })
  }

    componentDidMount(){
        if(this.Auth.loggedIn() && this.Auth.isAdmin()){
          this.setState({
            redirect: true
          })
        } else {
          this.setState({
            loading: false
          })
        }
      }

    render() {
      const teamLocation = window.location.pathname.split('/')[1] || "";
      let teamName = localStorage.getItem('team'+teamLocation);
      let teamLogo = localStorage.getItem('topLeftLogo'+teamLocation);
      if(teamLogo === "null" || !teamLogo){
        teamLogo = logoImage;
      }
      if (this.state.redirect === true) {
        let linkToGoTo = "/" + teamName + "/adminHome"
        return <Redirect to={linkToGoTo} />
      }
      teamName = teamName.charAt(0).toUpperCase() + teamName.substring(1);
        return (
            <div className="auth-fluid">
              <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
              <div className="auth-fluid-form-box">
                <div className="align-items-center d-flex h-100">
                    <div className="card-body">

                        <div className="auth-brand text-center text-lg-left" style={{marginBottom:'50px'}}>
                            <a href="/">
                                <span><img src={logoWithTextImageBlack} alt="" height="auto" width="200px"/></span>
                            </a>
                        </div>

                        <h4 className="mt-0" style={{fontWeight:'bolder', fontFamily:'Roboto'}}>Welcome {teamName}</h4>
                        <p className="text-muted2 mb-4" style={{fontWeight:'bold', fontFamily:'Roboto'}}>Enter your email address and password to access account.</p>

                        <form onSubmit={(event) => { this.authWithEmailPassword(event) }} ref={(form) => { this.loginForm = form }} style={{fontWeight:'bold', fontFamily:'Roboto'}}>
                            <div className="form-group">
                                <label htmlFor="emailaddress">Email address</label>
                                <input className="form-control" type="email" name="email" ref={(input) => { this.emailInput = input }} placeholder="Enter your email"/>
                            </div>
                            <div className="form-group">
                                {/*<a href="pages-recoverpw-2.html" className="text-muted float-right"><small>Forgot your password?</small></a>*/}
                                <label htmlFor="password">Password</label>
                                <input className="form-control" name="password" type="password" ref={(input) => { this.passwordInput = input }} placeholder="Enter your password"/>
                            </div>
                            <div className="form-group mb-0 text-center">
                                <button className="btn btn-primary btn-block" type="submit" style={{backgroundColor:"#ff1f3e", borderColor:"#ff1f3e", fontWeight:'bold', fontFamily:'Roboto'}}>Log In </button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

            <div className="auth-fluid-right text-center mobile-hide">
                <div className="auth-user-testimonial">
                    <h2 className="mb-3" style={{fontWeight:'bolder', fontFamily:'Roboto'}}>Scratcher & Win Tip Of The Month </h2>
                    <p className="lead" style={{fontWeight:'bold', fontFamily:'Roboto'}}>Plug the phone numbers collected into Facebook, Instagram, & Snapchat ads for ticketing retargeting (5x-8x returns)
                    </p>
                    <img src={teamLogo} width="200px" alt=""/>
                </div>
            </div>
        </div>
        );
    }
}

export default AdminLogin
